export const LEFT_SIDEBAR_WIDTH = '260px';

export const RIGHT_SIDEBAR_WIDTH = '320px';

export const MAIN_HEADER_HEIGHT = '60px';
export const VIEW_ONLY_MOBILE_HEIGHT = '90px'; // Needs extra space for the PreparedBy component on mobile

export const getHeaderHeight = ({
  isMobile,
  isViewOnly,
}: {
  isMobile: boolean;
  isViewOnly: boolean;
}) => {
  if (isMobile && isViewOnly) {
    return VIEW_ONLY_MOBILE_HEIGHT;
  }

  return MAIN_HEADER_HEIGHT;
};

export const CHAT_WIDTH = '350px';
